import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1, graphicDataColor2, graphicDataColor3 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const AreaXYZPlot = forwardRef(({ metrics }, ref) => {
  const [positions, setPositions] = useState([]);
  const [areaX, setAreaX] = useState([]);
  const [areaY, setAreaY] = useState([]);
  const [areaZ, setAreaZ] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let areaX = [];
    let areaY = [];
    let areaZ = [];

    const validateArea = (metric) => metric.hasOwnProperty("area(x,y,z)");
    const getArea = (metric, position) => metric["area(x,y,z)"].split(",")[position];

    metrics.forEach((metric, i) => {
      positions.push(i + 1);

      areaX.push(validateArea(metric) ? getArea(metric, 0) : NaN);
      areaY.push(validateArea(metric) ? getArea(metric, 1) : NaN);
      areaZ.push(validateArea(metric) ? getArea(metric, 2) : NaN);
    });

    setPositions(positions);
    setAreaX(areaX);
    setAreaY(areaY);
    setAreaZ(areaZ);

    return () => {
      setPositions([]);
      setAreaX([]);
      setAreaY([]);
      setAreaZ([]);
    };
  }, [metrics]);

  const area_X_Y_Z_Data = {
    labels: positions,
    datasets: [
      {
        label: t("reports_area_X_Y_Z_Graphic_legend1"),
        data: areaX,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
      {
        label: t("reports_area_X_Y_Z_Graphic_legend2"),
        data: areaY,
        backgroundColor: [graphicDataColor2],
        borderColor: [graphicDataColor2],
      },
      {
        label: t("reports_area_X_Y_Z_Graphic_legend3"),
        data: areaZ,
        backgroundColor: [graphicDataColor3],
        borderColor: [graphicDataColor3],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("reports_area_X_Y_Z_Graphic_title")}
        Type={Line}
        data={area_X_Y_Z_Data}
        axisY={t("reports_area_X_Y_Z_Graphic_axisY")}
        axisX={t("sessions")}
        graphicDescription={t("graphics_area_X_Y_Z_Description_App")}
        isBeta
      />
    </GraphicContainer>
  );
});

export default AreaXYZPlot;
